var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('courseLeadersList',{attrs:{"list":_vm.items,"headers":_vm.headers,"loading":_vm.loading},on:{"reload-list":_vm.load}})}
var staticRenderFns = []

export { render, staticRenderFns }